import React from "react";
import useWindowDimensions from "../../core/WindowDimensions/useWindowDimensions"
import "./ProgressBarStyles.css";
import "bootstrap/dist/css/bootstrap.css"

function ProgressBarBonus({ percent = 25, styleBonus = "profile", isCompleted = false }) {
  const { width } = useWindowDimensions();
  let backgroundHeight = 32
  let progressBarHeight = 40
  let icon = require("./icon.png")
  let bonusText = "Complete your profile bonus"
  if (styleBonus === "profile") {
    percent = 15
    if (isCompleted) bonusText = "Profile bonus added"
    else bonusText = "Complete your profile bonus"
  }
  else if (styleBonus === "remote-app") {
    if (isCompleted) bonusText = "Install Simple Roku Remote App bonus added"
    else bonusText = "Install Simple Roku Remote App +"
  }
  else if (styleBonus === "roku-remote-app") {
    if (isCompleted) bonusText = "Install Roku Movie Remote App bonus added"
    else bonusText = "Install Roku Movie Remote App"
  }
  else if (styleBonus === "ext-remote-app") {
    if (isCompleted) bonusText = "Install Roku Remote Extension bonus added"
    else bonusText = "Install Roku Remote Extension"
  }
  else if (styleBonus === "rate") {
    percent = 15
    if (isCompleted) bonusText = "Rating bonus added"
    else bonusText = "Rate The Movie House bonus"
  } else if (styleBonus === "email") {
    percent = 20
    if (isCompleted) bonusText = "Confirm email bonus added"
    else bonusText = "Confirm your email address"
  }

  let fontSize = 16
  if (width < 650) {
    fontSize = 13
    backgroundHeight = backgroundHeight * 0.75
    progressBarHeight = progressBarHeight * 0.75
  }



  const marginTop = -(progressBarHeight + backgroundHeight) / 2

  const progressBarStyle = {
    "width": percent < 0.5 ? "0.5%" : String(percent) + "%",
    "marginTop": marginTop,
    "height": progressBarHeight,
    "backgroundColor": isCompleted ? "#C8CFC7" : "#20B400",
  }

  const progressBarTextStyle = {
    "fontSize": String(fontSize) + "px",
    "width": percent < 0.5 ? "0.5%" : String(percent) + "%",
    "height": backgroundHeight
  }

  const progressBarTextStyle2 = {
    "fontSize": String(fontSize) + "px",
    "width": String(100 - percent) + "%",
    "height": backgroundHeight,
    "marginLeft": percent < 0.5 ? "0.5%" : String(percent - 5) + "%",
    "marginTop": "2px"
  }

  const buttonStyle = {
    "textDecoration": isCompleted ? "" : "underline"
  }


  return (
    <div className="progress-bar-wrapper">
      <div className="progress-bar-background" style={{ "height": backgroundHeight }} />
      <div className={isCompleted ? "progress-bar progress-bar-striped-disabled" : ("progress-bar active " + (styleBonus === "remote-app" ? " progress-bar-striped-v3" : " progress-bar-striped-v2"))} role="progressbar" style={progressBarStyle} >
        {!isCompleted && <div className="progress-bar progress-bar-striped active" role="progressbar"
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "#ffffff00"
          }} />}
      </div>
      <div style={progressBarTextStyle} className="progress-text"><button>{String(percent.toFixed(1)) + "%"}</button></div>
      <div style={progressBarTextStyle2} className="progress-text-2">
        <button style={buttonStyle}>
          {bonusText}
          <img style={isCompleted ? {} : { display: "none" }} alt="icon" className="progress-complete-icon" src={icon} />
        </button>
      </div>
    </div>
  );
}

export default ProgressBarBonus;
